import type { StrategyPreset } from './api.js';

/**
 * Имя пресета на экране: витринные имена (ONE, GUARD…) одинаковы на всех языках,
 * у «Кастом» имя на языке пользователя — приходит ключом i18n (`labelKey`).
 */
export function strategyName(
  preset: Pick<StrategyPreset, 'label' | 'labelKey'>,
  t: (key: string) => string,
): string {
  return preset.labelKey ? t(preset.labelKey) : preset.label;
}
